import React from 'react';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { PageSkeleton } from './PageSkeleton';

interface IProps {
    Fallback?: React.ReactNode;
}

const defaultProps: IProps = {
    Fallback: <PageSkeleton />,
};

export const LazyRoute: React.FC<React.PropsWithChildren<IProps>> = (props) => (
    <ErrorBoundary>
        <React.Suspense fallback={props.Fallback}>{props.children}</React.Suspense>
    </ErrorBoundary>
);

LazyRoute.defaultProps = defaultProps;
